export const ICON_TYPES = {
    STRING: 'string',
    SVG: 'svg',
};

export const STRING_ICON_MAX_LENGTH = 4;
